module.exports = __webpack_public_path__ + "img/vaccinated.af2db2d2.png";